export default __webpack_public_path__ + "static/media/share-preview-card.5815145a.png";